var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"label":_vm.label,"rows":"6","no-resize":""},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }